import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { makeReportingFetch } from '../dev/report-http'

export type SupabaseConfig = {
  url: string
  anonKey: string
}

let _client: SupabaseClient | undefined

export function createSupabaseClient(cfg: SupabaseConfig): SupabaseClient {
  if (_client) return _client
  // L5 dev:wrapping fetch 让 supabase-js 4xx/5xx 走 console.error → /__dev/log。
  // Prod CI 构建 reportingFetch = undefined,supabase-js 用默认 fetch,0 开销。
  const reportingFetch = makeReportingFetch()
  _client = createClient(cfg.url, cfg.anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
    ...(reportingFetch ? { global: { fetch: reportingFetch } } : {}),
  })
  return _client
}

export function getSupabase(): SupabaseClient {
  if (!_client) {
    throw new Error('Supabase client not initialized. Call createSupabaseClient(cfg) first.')
  }
  return _client
}
